import React from 'react';
import './DailyTimesheetForm.scss';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faTrash } from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export default class DailyTimesheetDeleteButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const { dailyTimesheet, onDeleteClick } = this.props;

        if (
            !dailyTimesheet.createdByCurrentUser ||
            (dailyTimesheet.timesheetStatusId != TimesheetStatus.New &&
                dailyTimesheet.timesheetStatusId != TimesheetStatus.Rejected)
        ) {
            return null;
        }

        const { showModal } = this.state;

        return (
            <>
                <Button
                    type="button"
                    color="danger"
                    onClick={this.toggleModal}
                    outline={true}
                >
                    <FontAwesomeIcon icon={faTrash} className="mr-1" />
                    Delete
                </Button>

                <Modal isOpen={showModal} size="lg" toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Delete Timesheet
                    </ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete your{' '}
                        {moment(dailyTimesheet.date).format(
                            MomentDateFormat.WeekDayNameAndDate
                        )}{' '}
                        timesheet?
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex w-100">
                            <Button
                                type="button"
                                color="warning"
                                onClick={this.toggleModal}
                                className="mr-auto"
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />
                                Cancel
                            </Button>

                            <Button
                                type="button"
                                color="success"
                                onClick={onDeleteClick}
                            >
                                <FontAwesomeIcon
                                    icon={faTrash}
                                    className="mr-1"
                                />
                                Delete
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
